import { render, staticRenderFns } from "./suggestions-page.vue?vue&type=template&id=eb2e1c00&scoped=true&"
import script from "./suggestions-page.vue?vue&type=script&lang=js&"
export * from "./suggestions-page.vue?vue&type=script&lang=js&"
import style0 from "./suggestions-page.vue?vue&type=style&index=0&id=eb2e1c00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2e1c00",
  null
  
)

export default component.exports